import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	PetitionDetailsDeleteMediaHit,
	type PetitionDetailsDeleteMediaHitMutation,
	type PetitionDetailsDeleteMediaHitMutationVariables,
} from './index.graphql';

export async function deleteMediaHit(
	mediaId: string,
	utilityContext: UtilityContext,
): Promise<PetitionDetailsDeleteMediaHitMutation | null | undefined> {
	const {
		gql: { fetch },
	} = utilityContext;

	const { data } = await fetch<PetitionDetailsDeleteMediaHitMutation, PetitionDetailsDeleteMediaHitMutationVariables>({
		query: PetitionDetailsDeleteMediaHit,
		variables: {
			input: {
				commentId: mediaId,
			},
		},
		rejectOnError: true,
	});
	return data;
}
